import { Image } from "antd";
import Carousel from "./components/Carousel";
import Slogan from "./components/Slogan";
import rightImage from "./images/top-image.png";
import styles from "./style.module.scss";

const TopArea = ({ data, showButton }) => {
  return (
    <div className={styles.topArea}>
      <div className={styles.left}>
        <Slogan showButton={showButton} />
        <Carousel data={data} />
      </div>
      <div className={styles.right}>
        <Image src={rightImage} alt="image" preview={false} className={styles.img} />
      </div>
    </div>
  );
};

export default TopArea;
